// Copyright 2026. WebPros International GmbH. All rights reserved.

import { styled } from 'styled-components';
import { COLORS } from 'common/theme';

export const ItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 6px;
    border-bottom: 1px solid ${COLORS.GREY_30};

    &:last-child {
        border-bottom: none;
    }
`;

export const ItemValue = styled.div`
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
`;
